export enum STRIPE_CONNECT_STATUS {
	NOT_CONNECT = 'not_connect',
	INCOMPLETE = 'incomplete',
	IN_REVIEW = 'in_review',
	SUCCEEDED = 'succeeded',
	FAILED = 'failed',
}